/**
 * ハンバーガー: .js-hamburger で .topNav__inner を開閉
 * .js-go-top-search（ヘッダー「物件検索」・トップ追従バナー）: トップの .topSearch へ（同一ページならスムーズスクロール）
 * SP: ドロワー内アコーディオンは slideDown / slideUp
 */
export function init() {
	if (typeof window.$ === 'undefined') return;
	const $ = window.$;
	const $btn = $('.js-hamburger');
	const $inner = $('.topNav__inner');
	if (!$inner.length) return;

	const ACCORDION_MS = 300;
	const $overlay = $('<div class="js-hamburger-overlay l-hamburger-overlay" style="display:none;position:fixed;inset:0;z-index:249;"></div>');
	$('body').append($overlay);

	const mqPc = window.matchMedia('(min-width: 768px)');

	function $accordionPanels() {
		return $inner.find('.l-header__drawerAccordion-panel');
	}

	function syncAccordionA11y() {
		const isPc = mqPc.matches;
		$inner.find('.js-drawer-accordion-btn').each(function () {
			const $b = $(this);
			const $block = $b.closest('.js-drawer-accordion');
			if (isPc) {
				$b.attr('aria-expanded', 'true');
			} else {
				$b.attr('aria-expanded', $block.hasClass('is-open'));
			}
		});
	}

	function resetSpAccordionPanels() {
		$inner.find('.js-drawer-accordion').removeClass('is-open');
		$accordionPanels().stop(true, true).hide();
	}

	function preparePcAccordionPanels() {
		$accordionPanels().stop(true, true).css({ display: '', height: '', overflow: '', paddingTop: '', paddingBottom: '' });
	}

	function openNav() {
		$inner.removeClass('is-closing').addClass('is-open');
		$overlay.fadeIn(200);
		if ($btn.length) {
			$btn.attr('aria-expanded', 'true');
			$btn.addClass('is-open');
		}
		if (mqPc.matches) {
			$inner.find('.js-drawer-accordion').addClass('is-open');
			preparePcAccordionPanels();
		}
		syncAccordionA11y();
	}

	function scrollToTopSearch() {
		const el = document.querySelector('.topSearch');
		if (!el) return;
		const instant = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		el.scrollIntoView({ behavior: instant ? 'auto' : 'smooth', block: 'start' });
	}

	function closeNav() {
		$inner.addClass('is-closing').removeClass('is-open');
		$overlay.fadeOut(350);
		if ($btn.length) {
			$btn.attr('aria-expanded', 'false');
			$btn.removeClass('is-open');
		}
		$inner.one('transitionend', function () {
			$inner.removeClass('is-closing');
		});
		if (!mqPc.matches) {
			resetSpAccordionPanels();
		}
		syncAccordionA11y();
	}

	if ($btn.length) {
		$btn.on('click', function () {
			if ($inner.hasClass('is-open')) closeNav();
			else openNav();
		});
	}

	$(document).on('click', '.js-go-top-search', function (e) {
		if (!document.querySelector('.topSearch')) return;
		e.preventDefault();
		if ($inner.hasClass('is-open')) closeNav();
		scrollToTopSearch();
	});

	$overlay.on('click', closeNav);
	$inner.on('click', 'a[href]', function () {
		if ($inner.hasClass('is-open')) closeNav();
	});
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $inner.hasClass('is-open')) closeNav();
	});

	$inner.on('click', '.js-drawer-accordion-btn', function (e) {
		if (mqPc.matches) return;
		e.preventDefault();
		e.stopPropagation();
		const $toggle = $(this);
		const $block = $toggle.closest('.js-drawer-accordion');
		const $panel = $block.find('.l-header__drawerAccordion-panel').first();
		const open = $block.hasClass('is-open');

		if (open) {
			$panel.stop(true, false).slideUp(ACCORDION_MS, function () {
				$block.removeClass('is-open');
				$toggle.attr('aria-expanded', 'false');
			});
		} else {
			// is-open 付与で CSS の display:none が外れるため、先に非表示にしてから slideDown する
			$panel.hide();
			$block.addClass('is-open');
			$toggle.attr('aria-expanded', 'true');
			$panel.stop(true, false).slideDown(ACCORDION_MS);
		}
	});

	const onMqChange = () => {
		if (mqPc.matches) {
			$inner.find('.js-drawer-accordion').addClass('is-open');
			preparePcAccordionPanels();
		} else {
			resetSpAccordionPanels();
		}
		syncAccordionA11y();
	};
	if (typeof mqPc.addEventListener === 'function') {
		mqPc.addEventListener('change', onMqChange);
	} else {
		mqPc.addListener(onMqChange);
	}
	onMqChange();
}
